/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface CreateServiceprovider201Response
 */
export interface CreateServiceprovider201Response {
    /**
     * 
     */
    message: string;
    /**
     * 
     */
    uuid?: string;
}

/**
 * Check if a given object implements the CreateServiceprovider201Response interface.
 */
export function instanceOfCreateServiceprovider201Response(value: object): value is CreateServiceprovider201Response {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function CreateServiceprovider201ResponseFromJSON(json: any): CreateServiceprovider201Response {
    return CreateServiceprovider201ResponseFromJSONTyped(json, false);
}

export function CreateServiceprovider201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateServiceprovider201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
    };
}

export function CreateServiceprovider201ResponseToJSON(json: any): CreateServiceprovider201Response {
    return CreateServiceprovider201ResponseToJSONTyped(json, false);
}

export function CreateServiceprovider201ResponseToJSONTyped(value?: CreateServiceprovider201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'uuid': value['uuid'],
    };
}

